import React, { useState } from 'react';
import { Loader2, Lock } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { startHostedPayment } from '@/lib/billingApi';

const Fact = ({ label, value, testId }) => (
  <div className="flex items-baseline justify-between gap-4 py-1.5">
    <span className="text-sm text-slate-500">{label}</span>
    <span className="text-sm font-semibold text-slate-800 text-right" data-testid={testId}>{value}</span>
  </div>
);

// Shared confirm + consent step for plan switches; the hosted card page does the rest.
export const PlanSwitchDialog = ({ onClose, testId, eyebrow, title, description, facts, consentText, payLabel, path }) => {
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);

  const pay = async () => {
    setBusy(true);
    try {
      await startHostedPayment(path, { consent: true });
    } catch (e) { toast.error(e.message); setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o && !busy) onClose(); }}>
      <DialogContent className="sm:max-w-md" data-testid={`${testId}-dialog`}>
        <DialogHeader>
          <p className="text-[11px] tracking-[0.2em] uppercase font-bold text-amber-600">{eyebrow}</p>
          <DialogTitle className="text-2xl font-black uppercase text-[#00247D]" style={{ fontFamily: 'Barlow Condensed' }}>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="rounded-xl bg-slate-50 border border-slate-200 px-4 py-2 divide-y divide-slate-200">
          {facts.map((f) => <Fact key={f.label} {...f} />)}
        </div>
        <label className="flex items-start gap-2.5 text-xs text-slate-600 cursor-pointer" htmlFor={`${testId}-consent`}>
          <Checkbox id={`${testId}-consent`} checked={consent} onCheckedChange={(v) => setConsent(!!v)} className="mt-0.5" data-testid={`${testId}-consent`} />
          <span>{consentText}</span>
        </label>
        <Button onClick={pay} disabled={!consent || busy} className="w-full h-12 bg-[#00247D] hover:bg-[#001A5C] font-bold" data-testid={`${testId}-pay-btn`}>
          {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Lock className="w-4 h-4 mr-2" />}{payLabel}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
